import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./app.css";

const HomePage = lazy(() => import("./areas/home/home-page"));
const Studio = lazy(() => import("./areas/studio/studio"));
const Viewer = lazy(() => import("./areas/viewer/viewer"));

function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-live="polite">
      Loading…
    </div>
  );
}

export function AppRoutes() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/studio/*" element={<Studio />} />
        <Route path="*" element={<Viewer />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
